/* @flow */
import React from 'react';
import { inject, observer } from 'mobx-react';
import { Trans, translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import styles from '../../../../ActionDrawer.module.scss';

@translate()
@inject('actionDrawerStore')
@observer
export default class TestError extends React.Component<*> {
  render(): React.Fragment {
    const {
      t,
      actionDrawerStore,
    }: {
      t: TranslatorProps,
      actionDrawerStore: TypeActionDrawerStore,
    } = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <h3>{t('general:error')}</h3>
          <Trans i18nKey="general:users.messages.not_revoked" parent="p">
            <u>{t('general:not')}</u>
          </Trans>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
